<template>
  <el-dialog class="dialog-cache" z-index="990" :visible.sync="dialogVisible" :close-on-press-escape="false" :close-on-click-modal="false" @close="onClose" width="90vw" top="5vh">
    <SelectMeterList v-if="dialogVisible" />
    <template #title>
      <el-button size="mini" @click="submit">确认（{{meter_list_num}}）</el-button>
      <el-button size="mini" @click="dialogVisible=false">取消</el-button>
    </template>
  </el-dialog>
</template>

<script>
import SelectMeterList from "./SelectMeterList";
export default {
  name: "SelectMeter",
  inject:['mainObj','componentId','setComponentId'],
  components: {SelectMeterList},
  provide(){
    return{
      selectMeter:this
    }
  },
  data(){
    return{
      dialogVisible:false,
      project_id:0,
      callback:"",
      meter_list:[],
    }
  },
  methods:{
    show(callback){
      this.project_id="";
      this.dialogVisible=true;
      this.callback=callback
    },
    submit(){
      typeof this.callback==="function"&&this.callback(this.meter_list)
      this.dialogVisible=false;
    },
    onClose(){
      this.project_id=null;
      this.callback=undefined;

    }
  },
  computed:{
    meter_list_num(){
      return this.meter_list.length;
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-cache{
  >>>.el-dialog__body{
    padding: 0 0 5px 0;
  }
  >>>.el-dialog__header{
    padding: 20px 20px 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/components/SelectMeter.vue